/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import DbBaseObject from "@shared/DbBaseObject";
import {FormSpecialFieldEnum} from "@/core/modules/coach/Resources/Forms/model/SpecialFieldEnum";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";

export default class BaseFormElement extends DbBaseObject {

	type: string = null

	title: string = ""
	description: string = ""
	answer: string = ""

	// set answer(val){
	// 	console.trace("BaseFormElement: set answer: ", val)
	// 	this.answer2 = val
	// }
	// get answer(){
	// 	// console.trace("BaseFormElement: set answer: ", this)
	// 	return this.answer2
	// }

	placeholder: string = "Question"

	disableEditing: boolean = false
	showTypeSelect: boolean = true
	showDescription: boolean = false
	showRequiredSwitch: boolean = true
	showDelete: boolean = true
	showCopy: boolean = true
	showScoring: boolean = false
	enableScoring: boolean = false
	isScoringManual: boolean = false
	isAutoScoreAscending: boolean = true
	isRequired: boolean = false

	// specialQuestionDescription: string = ""

	_answerPlaceholderAnswerMode: string = ""
	_answerPlaceholderResponseMode: string = ""
	_answerPlaceholderQuestionMode: string = ""

	_isSelected: boolean = false
	_index: number = -1

	constructor(type, title = "", isRequired = false) {
		super();
		if(!type){
			throw new Error("Type is required but it was not provided: ", this)
		}
		let options = this.setupOptions(type, title, isRequired)
		this.type = options.type || null
		this.title = options.title || null
		this.description = options.description || null
		this.isRequired = options.isRequired  || false
		this.resetElement()
	}

	getAnswerFormatted(){
		return this.answer
	}

	setDescription(description){
		this.description = description
		return this
	}


	resetElement() {
		this._answerPlaceholderAnswerMode = "Your answer"
		this._answerPlaceholderResponseMode = "No answer provided"
		this._answerPlaceholderQuestionMode = "Client's answer"

		this.answer = ""
		this.showTypeSelect = true
		this.showDescription = false
		this.showRequiredSwitch = true
		this.showDelete = true
		this.showCopy = true
		this.placeholder = "Question"
		this.disableEditing = false
		// this.specialQuestionDescription = ""
		this.showScoring = false
		this.enableScoring = false
		this.isAutoScoreAscending = true
		this.isScoringManual = false
	}

	fillOptionsFrom(formElement){

		this.isRequired = formElement.isRequired
		if(formElement.type === FormElementType.RADIOBUTTONS){
			this.enableScoring = formElement.enableScoring
		}
		this.isAutoScoreAscending = formElement.isAutoScoreAscending
		this.isScoringManual = formElement.isScoringManual
	}

	getValidateRules(){

	}

	// getValidatorFunction(rule, value, callback, source, options){
	//
	// }

	recalculateScoring(){

	}

	calculateMaxScore(){
		return 0
	}

	calculateAnswerScore(formItem, scoreAsBuckets = false){
		if(scoreAsBuckets){
			return this._calculateAnswerScoreAsBuckets(formItem)
		}
		return this._calculateAnswerScoreAsTotal(formItem)
	}

	_calculateAnswerScoreAsBuckets(formItem){
		return []
	}

	_calculateAnswerScoreAsTotal(formItem){
		return 0
	}

	getAnswer(){
		return this.answer
	}

	setAnswer(answer){
		this.answer = answer
	}

	isEmailItem(){
		return this.type === FormSpecialFieldEnum.EMAIL
	}

	isFullNameItem(){
		return this.type === FormSpecialFieldEnum.FULL_NAME
	}

	isTypeTitleOrFooter(){
		return this.isTypeTitle() || this.isTypeFooter()
	}

	isTypeTitle(){
		return this.type === FormElementType.TITLE
	}
	isTypeFooter(){
		return this.type === FormElementType.FOOTER
	}

	isSpecialFormElement() {
		let isSpecialElement = false
		Object.keys(FormSpecialFieldEnum).forEach(key => {
			console.log("isSpecialFormElement: key = ", key, ", FormSpecialFieldEnum[key] = ", FormSpecialFieldEnum[key], ", this = ", this)
			if (this.type === FormSpecialFieldEnum[key]) {
				isSpecialElement = true
			}
		})

		return isSpecialElement
	}

	autoScoreDirectionText(){
		return this.isAutoScoreAscending ? "ascending" : "descending"
	}

	isScoringEnabled(){
		return this.enableScoring && this.showScoring
	}

	getSmartFiledPropertyName(){

	}



	setupOptions(type, title, isRequired){
		let options = {}
		if(typeof type === "object"){
			options = type
		}
		if(typeof title === "object"){
			options = title
		}
		if(typeof isRequired === "object"){
			options = isRequired
		}
		if(typeof type === "string"){
			options.type = type
		}
		if(typeof title === "string"){
			options.title = title
		}
		if(typeof isRequired === "boolean"){
			options.isRequired = isRequired
		}
		return options
	}



}
